import { ICreativeSize } from '@/Interfaces/Creatives/CreativeSize.interface';
import axios from 'axios';

const creativeSizesEndpoint = '/reference/creative-sizes';

export const fetchCreativeSizes = async () => {
  const response = await axios.get<ICreativeSize[]>(creativeSizesEndpoint);
  return response.data;
};
